
import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import SkyQuoteScript from './SkyQuoteScript';
import BrandStyles from './BrandStyles';
import ElevenLabsWidget from './ElevenLabsWidget';
import SEOManager from '@/components/SEO/SEOManager';
import BreadcrumbSchema from '@/components/SEO/BreadcrumbSchema';
import { Toaster } from "@/components/ui/sonner";
import { Helmet } from 'react-helmet-async';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700&display=swap" />
        
        {/* Open Graph / Facebook Meta Tags */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Carolina Trophy Roofs | #1 Roofing Contractor in Eastern NC" />
        <meta property="og:description" content="Eastern NC's premier roofing contractor serving Rocky Mount, Greenville, Wilson, and surrounding areas. Expert residential and commercial roofing services with 24/7 emergency response." />
        <meta property="og:image" content={`${window.location.origin}/lovable-uploads/f22cc5c2-f23d-4f0c-96a2-9b2c477f2f7b.png`} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:site_name" content="Carolina Trophy Roofs" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Carolina Trophy Roofs | #1 Roofing Contractor in Eastern NC" />
        <meta name="twitter:description" content="Eastern NC's premier roofing contractor serving Rocky Mount, Greenville, Wilson, and surrounding areas. Expert residential and commercial roofing services with 24/7 emergency response." />
        <meta name="twitter:image" content={`${window.location.origin}/lovable-uploads/f22cc5c2-f23d-4f0c-96a2-9b2c477f2f7b.png`} />
        
        {/* Additional Social Media Meta Tags */}
        <meta property="fb:app_id" content="" />
        <meta name="twitter:site" content="@RoofsTrophy" />
        <meta name="twitter:creator" content="@RoofsTrophy" />
        
        {/* Google Analytics */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-JHDKWM4BSV"></script>
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-JHDKWM4BSV');
          `}
        </script>
      </Helmet>
      <SEOManager />
      <BreadcrumbSchema />
      <ScrollToTop />
      <SkyQuoteScript />
      <BrandStyles />
      <ElevenLabsWidget />
      <Navbar />
      <main className="flex-1">
        {children}
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Layout;
